<template>
  <gg-card>
    <gg-card-header>
      {{ item.title }}
    </gg-card-header>
    <gg-card-text>
      <v-row>
        <v-col cols="12" sm="4">
          <div v-for="(server, i) in item.affected_servers" :key="i">
            {{ server }}
          </div>
        </v-col>
        <v-col cols="12" sm="4" class="text-capitalize text-center">
          <v-icon small class="mb-1" :color="statusColor(item.status)">
            mdi-circle
          </v-icon>
          {{ item.status }}
        </v-col>
        <v-col cols="12" sm="4">
          <gg-btn :to="`/status/${item.id}`">View Details</gg-btn>
        </v-col>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
export default {
  name: 'DownTimeItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    statusColor (status) {
      switch (status) {
        case 'Investigating':
          return 'orange'
        case 'In Progress':
          return 'red'
        case 'Monitoring':
          return 'yellow'
        case 'Resolved':
          return 'green'
        default:
          return 'grey'
      }
    }
  }
}
</script>

<style scoped>

</style>
